// @ts-check
import { z } from 'zod';

import Timestamp from '@/store/modules/models/global/Timestamp';
import ImportedContacts from '@/store/modules/bulkSend/models/ImportedContacts';

export const ImportedRow = z.object({
  fingerprint: z.string(),
  csv_row_number: z.number(),
  envelope_title: z.string().nullable(),
  imported_contacts: ImportedContacts,
  created_at: Timestamp,
  updated_at: Timestamp,
});

export const ImportedRows = ImportedRow.array();
